/** Minimum idle time before a tab-focus catch-up sync runs again. */
export const INBOX_CATCH_UP_STALE_MS = 5 * 60 * 1000;

export function isInboxCatchUpStale(
  lastCatchUpAtMs: number | null,
  nowMs: number = Date.now(),
  staleAfterMs: number = INBOX_CATCH_UP_STALE_MS,
): boolean {
  if (lastCatchUpAtMs == null) return true;
  return nowMs - lastCatchUpAtMs >= staleAfterMs;
}

export function shouldScheduleInboxCatchUpSync(params: {
  visible: boolean;
  hasSyncSince: boolean;
  hasNylasGrant: boolean;
  inFlight: boolean;
  reason: 'mount' | 'focus' | 'interval';
  lastCatchUpAtMs: number | null;
  nowMs?: number;
  staleAfterMs?: number;
}): boolean {
  if (!params.visible) return false;
  if (!params.hasNylasGrant) return false;
  if (!params.hasSyncSince) return false;
  if (params.inFlight) return false;

  if (params.reason === 'focus' || params.reason === 'interval') {
    return isInboxCatchUpStale(
      params.lastCatchUpAtMs,
      params.nowMs,
      params.staleAfterMs ?? INBOX_CATCH_UP_STALE_MS,
    );
  }

  return true;
}
